import { useFormContext } from "react-hook-form"
import RadioInputContainer, {
  RadioInputTitle
} from "../../../common/form/radioInputContainer"
import BankID from "../../../common/icons/bankid"
import InvoiceIcon from "../../../common/icons/invoice"
import Mastercard from "../../../common/icons/mastercard"
import SwishIcon from "../../../common/icons/swish"
import { Trustly as TrustlyIcon } from "../../../common/icons/trustly"
import Visa from "../../../common/icons/visa"

function PaymentLogos({ children }) {
  return <div className="flex flex-row">{children}</div>
}

export function Swish({ id, title, selected }) {
  const { register } = useFormContext()

  return (
    <label htmlFor={id}>
      <RadioInputContainer className="cursor-pointer" selected={selected}>
        <input
          type="radio"
          {...register("paymentMethod")}
          id={id}
          value={id}
          className="absolute -z-1"
        />
        <RadioInputTitle selected={selected} title={title} />
        <PaymentLogos>
          <SwishIcon style={{ height: 27, width: 88 }} />
        </PaymentLogos>
      </RadioInputContainer>
    </label>
  )
}

export function CreditCard({ id, title, selected }) {
  const { register } = useFormContext()

  return (
    <label htmlFor={id}>
      <RadioInputContainer className="cursor-pointer" selected={selected}>
        <input
          type="radio"
          {...register("paymentMethod")}
          id={id}
          value={id}
          className="absolute -z-1"
        />
        <RadioInputTitle selected={selected} title={title} />
        <PaymentLogos className="flex h-auto">
          <Mastercard className="w-13 mr-3 border p-1 border-black-25 rounded" />
          <Visa className="w-13 border p-1 border-black-25 rounded" />
        </PaymentLogos>
      </RadioInputContainer>
    </label>
  )
}

export function Form({ id, title, selected }) {
  const { register } = useFormContext()

  return (
    <label htmlFor={id}>
      <RadioInputContainer className="cursor-pointer" selected={selected}>
        <input
          type="radio"
          {...register("paymentMethod")}
          id={id}
          value={id}
          className="absolute -z-1"
        />
        <RadioInputTitle selected={selected} title={title} />
      </RadioInputContainer>
    </label>
  )
}

export function Trustly({ id, title, selected }) {
  const { register } = useFormContext()

  return (
    <label htmlFor={id}>
      <RadioInputContainer className="cursor-pointer" selected={selected}>
        <input
          type="radio"
          {...register("paymentMethod")}
          id={id}
          value={id}
          className="absolute -z-1"
        />
        <RadioInputTitle selected={selected} title={title} />
        <PaymentLogos>
          <TrustlyIcon className="h-7" />
        </PaymentLogos>
      </RadioInputContainer>
    </label>
  )
}

export function Invoice({ id, title, selected }) {
  const { register } = useFormContext()

  return (
    <label htmlFor={id}>
      <RadioInputContainer className="cursor-pointer" selected={selected}>
        <input
          type="radio"
          {...register("paymentMethod")}
          id={id}
          value={id}
          className="absolute -z-1"
        />
        <RadioInputTitle selected={selected} title={title} />
        <PaymentLogos>
          <InvoiceIcon className="h-7 text-gray-70 opacity-80" />
        </PaymentLogos>
      </RadioInputContainer>
    </label>
  )
}

export function SuperOffice({ id, title, selected }) {
  const { register } = useFormContext()

  return (
    <label htmlFor={id}>
      <RadioInputContainer className="cursor-pointer" selected={selected}>
        <input
          type="radio"
          {...register("paymentMethod")}
          id={id}
          value={id}
          className="absolute -z-1"
        />
        <RadioInputTitle selected={selected} title={title} />
        <PaymentLogos>
          <InvoiceIcon className="h-7 text-gray-70 opacity-80" />
        </PaymentLogos>
      </RadioInputContainer>
    </label>
  )
}

export function Scrive({ id, title, selected }) {
  const { register } = useFormContext()

  return (
    <label htmlFor={id}>
      <RadioInputContainer className="cursor-pointer" selected={selected}>
        <input
          type="radio"
          {...register("paymentMethod")}
          id={id}
          value={id}
          className="absolute -z-1"
        />
        <RadioInputTitle selected={selected} title={title} />
        <PaymentLogos>
          <BankID />
        </PaymentLogos>
      </RadioInputContainer>
    </label>
  )
}

export function Bitio({ id, title, selected }) {
  const { register } = useFormContext()

  return (
    <label htmlFor={id}>
      <RadioInputContainer className="cursor-pointer" selected={selected}>
        <input
          type="radio"
          {...register("paymentMethod")}
          id={id}
          value={id}
          className="absolute -z-1"
        />
        <RadioInputTitle selected={selected} title={title} />
        <PaymentLogos>
          <BankID />
        </PaymentLogos>
      </RadioInputContainer>
    </label>
  )
}
